// Joya Headquarter — management views (overview, workspace, sales, ask). English.
// Same keys as mgmt.he.js.
export default {
  'joya.ov.title': 'Chain overview',
  'joya.ov.sub': 'Last 7 days',
  'joya.ov.chainTotals': 'Whole chain',
  'joya.ov.revenue': 'Sales',
  'joya.ov.checks': 'Checks',
  'joya.ov.diners': 'Diners',
  'joya.ov.avgCheck': 'Average per check',
  'joya.ov.revenueChange': 'Sales change',
  'joya.ov.moreVisits': 'more visits',
  'joya.ov.fewerVisits': 'fewer visits',
  'joya.ov.higherSpend': 'higher spend per check',
  'joya.ov.lowerSpend': 'lower spend per check',
  'joya.ov.checksWord': 'in checks',
  'joya.ov.and': 'and',
  'joya.ov.noCompare': 'Not enough data to compare with the week before.',
  'joya.ov.daysMissing_one': '1 day has no POS data — not counted as zero.',
  'joya.ov.daysMissing_other': '{count} days have no POS data — not counted as zero.',
  'joya.ov.chainMissing_one': '1 location-day of POS data is missing — the total does not include it.',
  'joya.ov.chainMissing_other': '{count} location-days of POS data are missing — the total does not include them.',
  'joya.ov.anomalies_one': '1 unusual day in the last two weeks.',
  'joya.ov.anomalies_other': '{count} unusual days in the last two weeks.',
  'joya.ov.see': 'Show',
  'joya.ov.dataAlerts': 'Data alerts',
  'joya.ov.p.draftLists': 'Draft order lists',
  'joya.ov.p.approvedNotOrdered': 'Approved, not ordered',
  'joya.ov.p.draftPlans': 'Draft shift plans',
  'joya.ov.p.openPayrollIssues': 'Open payroll issues',
  'joya.ov.p.shortages7d': 'Shortages (7 days)',
  'joya.ov.pendingTitle': 'Waiting for a decision',
  'joya.ov.noPending': 'Nothing is waiting for a decision.',
  'joya.ov.ex1': 'Which location had the biggest drop in sales last week, and why?',
  'joya.ov.ex2': 'Compare labor cost % between locations last month',

  'joya.ws.title': 'Restaurant workspace',
  'joya.ws.orderTitle': "Today's order list",
  'joya.ws.orderReady_one': 'There is a list with 1 item. Check it, edit it and approve it.',
  'joya.ws.orderReady_other': 'There is a list with {count} items. Check it, edit it and approve it.',
  'joya.ws.noOrderToday': 'There is no order list for today yet.',
  'joya.ws.generateList': 'Make an order proposal',
  'joya.ws.openList': 'Open the list',
  'joya.ws.otherDrafts_one': '1 other draft',
  'joya.ws.otherDrafts_other': '{count} other drafts',
  'joya.ws.shortageTitle': 'Quick shortage report',
  'joya.ws.shortageItem': 'What is missing?',
  'joya.ws.shortagePh': 'e.g. feta cheese',
  'joya.ws.shortageSend': 'Report',
  'joya.ws.shortageSaved': 'Report saved.',
  'joya.ws.shortageSavedText': 'Report saved, but the item is not in the ingredient list — it was saved as text.',
  'joya.ws.shortages7d': 'Shortages in the last 7 days',
  'joya.ws.seeAll': 'All',
  'joya.ws.shiftsTitle': "Next week's shifts",
  'joya.ws.weekOf': 'Week starting',
  'joya.ws.people_one': '1 person in total in the proposal.',
  'joya.ws.people_other': '{count} staff slots in total in the proposal.',
  'joya.ws.openPlan': 'Open the plan',
  'joya.ws.proposePlan': 'Make a weekly proposal',
  'joya.ws.salesTitle': "Yesterday's sales",
  'joya.ws.vsDayBefore': 'vs the day before',
  'joya.ws.noSalesYesterday': 'No POS data for yesterday yet.',
  'joya.ws.payrollTitle': 'Payroll preparation checks',
  'joya.ws.payrollOpen': 'Open issues',
  'joya.ws.payrollHint': 'Missing clock times, duplicates and differences. Final payroll approval stays with you.',
  'joya.ws.ex1': 'How many diners did we have last night compared with last week?',
  'joya.ws.ex2': 'Which dishes sold more this week?',
  'joya.ws.ex3': "What is missing in this location's data?",

  'joya.sales.title': 'Sales & performance',
  'joya.sales.sub': 'From Beecomm POS data, read from Allegro. A day with no data is marked missing, not zero.',
  'joya.sales.last7': '7 days',
  'joya.sales.last28': '28 days',
  'joya.sales.tabSummary': 'Summary',
  'joya.sales.tabDaily': 'By day',
  'joya.sales.tabShifts': 'By shift',
  'joya.sales.tabDishes': 'By dish',
  'joya.sales.tabAnomalies': 'Unusual days',
  'joya.sales.prevRevenue': 'Sales in the previous period',
  'joya.sales.avgDiner': 'Average per diner',
  'joya.sales.avgDinerUnknown': 'Many checks have no diner count',
  'joya.sales.volumeEffect': 'Effect of the number of visits',
  'joya.sales.spendEffect': 'Effect of spend per check',
  'joya.sales.formulaHelp': 'C = number of checks, A = average per check. The two parts add up to the sales change.',
  'joya.sales.coverage': 'Days with data',
  'joya.sales.legendRevenue': 'Sales',
  'joya.sales.legendMissing': 'No data — not zero',
  'joya.sales.noData': 'no data',
  'joya.sales.checksShort': 'checks',
  'joya.sales.dinersShort': 'diners',
  'joya.sales.noShifts': 'No shifts are defined for this location.',
  'joya.sales.outside': 'Outside shift hours',
  'joya.sales.prevShort': 'before:',
  'joya.sales.notOnMenu': 'not on the menu',
  'joya.sales.units': 'Units',
  'joya.sales.unitsChange': 'Change in units',
  'joya.sales.noPrev': 'No sales in the previous period to compare with',
  'joya.sales.method': 'Method',
  'joya.sales.noAnomalies': 'No unusual days in this period.',
  'joya.sales.actual': 'Actual',
  'joya.sales.expected': 'Expected (median)',
  'joya.sales.basis': 'Compared with the same weekday in the previous {weeks} weeks.',
  'joya.sales.missingTitle': 'Days with no POS data',
  'joya.sales.missingHelp': 'These days have no Beecomm data in Allegro — they are not counted as zero.',



  'joya.askPage.title': 'Ask headquarters',
  'joya.askPage.howTitle': 'How an answer is made',
  'joya.askPage.how1': 'You ask in words, in Hebrew or English.',
  'joya.askPage.how2': 'The system runs calculations on your data — only on the locations and data you are allowed to see.',
  'joya.askPage.how3': 'The language model writes only the words. Every number comes from the calculations, not from the model.',
  'joya.askPage.how4': 'Under each answer you see the calculations, with their period and data source.',
  'joya.askPage.how5': 'A number in the answer that is not in the calculations gets a warning, so you can check it.',
  'joya.askPage.scope': 'Questions are about the location chosen at the top of the page (or all your locations).',
  'joya.askPage.ex1': 'What were sales last week compared with the week before?',
  'joya.askPage.ex2': 'Which dishes grew the most this month?',
  'joya.askPage.ex3': 'What was the labor cost % last month?',
  'joya.askPage.ex4': 'How much did we sell per labor hour last week?',
  'joya.askPage.ex5': 'Which data is missing or out of date?',
  'joya.askPage.ex6': 'Show demand on recent Thursdays',
};
